export default {
  FETCH_PROGRAM_INFO: 'FETCH_PROGRAM_INFO',
  FETCH_PROGRAM_INFO_SUCCESS: 'FETCH_PROGRAM_INFO_SUCCESS',
  FETCH_PROGRAM_INFO_FAILURE: 'FETCH_PROGRAM_INFO_FAILURE',

  FETCH_MODULE: 'FETCH_MODULE',
  FETCH_MODULE_SUCCESS: 'FETCH_MODULE_SUCCESS',
  FETCH_MODULE_FAILURE: 'FETCH_MODULE_INFO_FAILURE',

  SUBMIT_COMPLETE_MODULE_SECTION: 'SUBMIT_COMPLETE_MODULE_SECTION',
  SUBMIT_COMPLETE_MODULE_SECTION_SUCCESS: 'SUBMIT_COMPLETE_MODULE_SECTION_SUCCESS',
  SUBMIT_COMPLETE_MODULE_SECTION_FAILURE: 'SUBMIT_COMPLETE_MODULE_SECTION_FAILURE',

  FETCH_PROGRAM_FUNDRAISER: 'FETCH_PROGRAM_FUNDRAISER',
  FETCH_PROGRAM_FUNDRAISER_SUCCESS: 'FETCH_PROGRAM_FUNDRAISER_SUCCESS',
  FETCH_PROGRAM_FUNDRAISER_FAILURE: 'FETCH_PROGRAM_FUNDRAISER_FAILURE',

  TOGGLE_SECTION_OPEN_STATUS: 'TOGGLE_SECTION_OPEN_STATUS',

  ENROLL_FOR_PROGRAM_ON_MODULE: 'ENROLL_FOR_PROGRAM_ON_MODULE',
  ENROLL_FOR_PROGRAM_ON_MODULE_SUCCESS: 'ENROLL_FOR_PROGRAM_ON_MODULE_SUCCESS',
  ENROLL_FOR_PROGRAM_ON_MODULE_FAILURE: 'ENROLL_FOR_PROGRAM_ON_MODULE_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/programs/module/actionTypes.js